export default "__VITE_PUBLIC_ASSET__4aed0e1a__"